import { put } from 'redux-saga/effects';

import { MetaWithCallback } from '../../shared.types';
import { notificationError } from './notificationUtils';
import { composeErrorMessage } from './utils';

export function successHandler<Response = undefined>(
  meta: MetaWithCallback<Response | undefined> | undefined | null,
  response?: Response,
) {
  if (meta && meta.onSuccess) {
    meta.onSuccess(response);
  }
}

export function errorHandler<Error = undefined>(
  meta: MetaWithCallback<void, Error | undefined> | undefined | null,
  error?: Error,
) {
  if (meta && meta.onError) {
    meta.onError(error);
  }
}

export function* compose403ErrorMessage(err) {
  yield put(notificationError(err.status === 403 ? 'app:not_allowed_to_do_this' : composeErrorMessage(err)));
}
